import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { XCircle } from 'lucide-react';

export default function CheckoutFailedPage() {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-neutral-950 flex flex-col">
      <div className="flex flex-1 flex-col items-center justify-center px-4 py-16">
        <Link
          to="/"
          className="mb-12 inline-block"
          aria-label="Maison Adji"
        >
          <img
            src="/assets/images/maisonadjiwhite.png"
            alt="Maison Adji"
            className="h-8 w-auto object-contain opacity-90 hover:opacity-100 transition-opacity"
          />
        </Link>

        <div className="w-full max-w-md text-center">
          <div className="mx-auto mb-8 flex h-20 w-20 items-center justify-center rounded-full border border-white/10 bg-white/5">
            <XCircle className="h-12 w-12 text-red-400/90" />
          </div>
          <h1 className="font-['Sora'] text-2xl md:text-3xl font-light tracking-tight text-white mb-4">
            {t('checkout.failed_title')}
          </h1>
          <p className="font-['Rubik'] text-sm text-white/60 leading-relaxed mb-10">
            {t('checkout.failed_message')}
          </p>

          <div className="flex flex-col gap-3">
            <Link
              to="/"
              className="inline-flex w-full items-center justify-center rounded-full border border-white/30 bg-white px-6 py-4 font-['Rubik'] text-xs tracking-[0.2em] uppercase text-neutral-900 transition-colors hover:bg-white/90"
            >
              {t('checkout.failed_home')}
            </Link>
            <Link
              to="/"
              className="inline-flex w-full items-center justify-center rounded-full border border-white/20 px-6 py-4 font-['Rubik'] text-xs tracking-[0.2em] uppercase text-white/80 transition-colors hover:bg-white/10 hover:text-white"
            >
              {t('checkout.failed_cart')}
            </Link>
          </div>
        </div>
      </div>

      <footer className="border-t border-white/10 py-6 text-center">
        <p className="font-['Rubik'] text-xs text-white/30 tracking-widest uppercase">
          Maison Adji
        </p>
      </footer>
    </div>
  );
}
